import { Subscription } from "../../Signal";
import { TemplateContext } from "../Template";



/**
 * Super class of all expressions to store the expression and its context.
 * It handles also the subscription on observables
 */
export abstract class Expression {

	expression:Function;
	context:TemplateContext;

	constructor( context:TemplateContext ) {
		this.context = context;
	}

	abstract destroy();
}


export interface ExpressionWithInital {
	inital();
}

/**
 * A guard that checks whether the specified object has an inital function to invoke
 *
 * @param obj The object that should be tested.
 */
export function hasInital( obj:any ):obj is ExpressionWithInital {
	return obj && obj[ 'inital' ];
}




export function snakeToCamel( string ):string {
	return string.replace( /(\-\w)/g, match => match[1].toUpperCase() );
}

export function camelToSnake( string ) {
	return string.split(/(?=[A-Z])/).join('-').toLowerCase();
}

